import { useGlobalStore } from '@/hoxStore/globalStore'
import { Pagination } from 'antd'
import { use } from 'i18next'
import { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const MePagination = ({
  total = 0,
  currentPage = 1,
  pageSize = 10,
  loading = false,
  setPageParams,
}: {
  total?: number
  currentPage?: number
  pageSize?: number
  loading?: boolean
  setPageParams?: Dispatch<SetStateAction<{ page: number; offset: number; limit: number }>>
}) => {
  const { curReponsive } = useGlobalStore()
  const currentPageRef = useRef(pageSize)
  const { t } = useTranslation()
  const timeId = useRef<NodeJS.Timeout | null>(null)
  const onChange = (page: number, pageSize: number) => {
    if (currentPageRef.current !== pageSize) {
      currentPageRef.current = pageSize
      setPageParams?.({ page: 1, offset: 0, limit: pageSize })
    } else {
      setPageParams?.({ page, offset: page * pageSize - pageSize, limit: pageSize })
    }
  }

  timeId.current = setTimeout(() => {
    const inputEl = document.querySelectorAll(
      '.gea_pagination_wrap .ant-select-selection-search-input',
    )
    const antPaginationOptionsQuickJumper = document.querySelectorAll(
      '.gea_pagination_wrap .ant-pagination-options-quick-jumper input',
    )
    if (inputEl) {
      inputEl.forEach((item) => {
        console.log('item', item)
        item.setAttribute('disabled', 'disabled')
      })
    }
    if (antPaginationOptionsQuickJumper) {
      if (curReponsive?.size !== 'mobile') {
        antPaginationOptionsQuickJumper.forEach((item) => {
          item.removeAttribute('type')
          item.removeAttribute('inputmode')
        })
      } else {
        antPaginationOptionsQuickJumper.forEach((item) => {
          item.setAttribute('type', 'number')
          item.setAttribute('inputmode', 'numeric')
        })
      }
    }
    timeId.current = null
  }, 1000)

  if (total === 0) return null
  return (
    <div className={'gea_pagination_wrap'}>
      <Pagination
        disabled={loading}
        current={currentPage}
        total={total}
        pageSize={pageSize}
        showQuickJumper={false}
        showLessItems={curReponsive?.size === 'mobile'}
        // hideOnSinglePage
        onChange={onChange}
        pageSizeOptions={['10']}
        jumpNextIcon={<div>...</div>}
        jumpPrevIcon={<div>...</div>}
        showSizeChanger={false}
        locale={{
          items_per_page: t('explorer_149'),
          jump_to: t('explorer_148'),
          page: '',
        }}
      />
    </div>
  )
}

export default MePagination

// locale={{
//     items_per_page: '条/页',
//     jump_to: '跳至',
//     jump_to_confirm: '确定',
//     page: '',
//     prev_page: '上一页',
//     next_page: '下一页',
//       prev_5: '向前5页',
//       next_5: '向后5页',
//       prev_3: '向前3页',
//       next_3: '向后3页',
//   }}
